import moment from 'moment';

class LicensePopupController {
    constructor($scope, licenseService) {
        'ngInject';
        this.$scope = $scope;
        this.licenseService = licenseService;
        this.loading = true;
    }

    $onInit() {
        this.licenseService.get(this.resolve.companyId)
            .then(licenseData => {

                this.userCount = licenseData.numberOfUsers;
                this.projectCount = licenseData.numberOfProjects;
                this.name = licenseData.name;
                this.avatarUrl = licenseData.avatarUrl;
                this.licenseId = licenseData.licenseId;
                this.nextBillingDate = moment(licenseData.nextBillingDate);
                this.licenses = licenseData.licenses;
                this.extraCharge = 0;
                this.hasOtherOwnCompanyWithBasicLicense = licenseData.hasOtherOwnCompanyWithBasicLicense
                this.onLicenseSelect();
                this.loading = false;
            });
    }

    noChanges() {
        if(!this.origLicense) {
            return true;
        }
        return this.origLicense.licenseId === this.licenseId;
    }

    onLicenseSelect() {
        this.selectedLicense = this.licenses.find(license => license.licenseId === this.licenseId);
        this.origLicense = this.origLicense || this.selectedLicense;
        const tooManyUsers = () => this.userCount > this.selectedLicense.maxNumberOfUsers;
        const tooManyProjects = () => this.projectCount > this.selectedLicense.maxNumberOfProjects;
        if (tooManyUsers() && tooManyProjects()) {
            this.errors = 'both';
        } else if (tooManyUsers()) {
            this.errors = 'users';
        } else if (tooManyProjects()) {
            this.errors = 'projects';
        } 
        else if (this.hasOtherOwnCompanyWithBasicLicense && this.licenseId === 1)
        {
            this.errors = 'companies';
        }
        else {
            this.errors = '';
        }
        this.effectiveNumberOfUser = Math.max(this.selectedLicense.minNumberOfUsers, this.userCount );
        this.nextBillingAmount = this.effectiveNumberOfUser * this.selectedLicense.costPerUser;
       // this.extraCharge = Math.round((this.selectedLicense.monthlyCost / moment().daysInMonth() - this.origLicense.monthlyCost / moment().daysInMonth()) * Math.ceil(moment.duration(this.nextBillingDate.diff(moment.now())).asDays()) * 100) / 100;
        this.$scope.$apply();
    }

    save() {
        this.licenseService.save(this.resolve.companyId, this.licenseId)
            .then(() => this.close());
    }

    undo() {
        this.licenseId = this.origLicense.licenseId;
        this.onLicenseSelect();
    }
}

export default LicensePopupController;


// WEBPACK FOOTER //
// ./components/popups/license-popup/popup/license-popup.controller.js